import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing a record table for casino report view.
 * @extends JetView
 */
export default class recordTableCasinoReportView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        return {
            view: 'datatable', // Defines the view type
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            columns: [
                // Column definitions for the datatable
                { id: 'Id', header: 'Id', width: 100, sort: 'int' }, // Column for Id
                {
                    id: 'TransactionId',
                    header: _('Transacción ID'), // Localized header for Transaction ID
                    width: 100,
                    sort: 'int',
                },
                { id: 'Type', header: _('Tipo'), width: 100, sort: 'int' }, // Localized header for Type
                {
                    id: 'Amount',
                    header: _('Valor'), // Localized header for Amount
                    width: 100,
                    format: webix.i18n.priceFormat, // Formatting for price
                    exportType: 'number', // Export type for Amount
                    sort: 'int',
                },
            ],
            loadahead: 0, // Number of rows to load ahead
            datafetch: devConfig.getDefaultDataFetch(), // Default data fetch configuration
            pager: 'pagerA', // Pager configuration
        };
    }

    /**
     * Initializes the grid and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        this.on(this.app, 'user:id', (idUser) => {
            // Event listener for user ID
            grid.load(
                devConfig.geturlApi() + // API URL for loading data
                    'null/Report/GetCasinoGamesReportDetail' +
                    '?id=' +
                    idUser, // User ID parameter for API call
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Get the clicked item
            this.$scope.app.callEvent('casinoTransDetail:select', [item]); // Trigger event with selected item
        });
    }
}

// FILE DOCUMENTED
